import React, { useState } from 'react';
import { View, Text, StyleSheet, SafeAreaView, Dimensions, PixelRatio } from 'react-native';
import AppIntroSlider from 'react-native-app-intro-slider';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Colours from '../../utils/Colours';
import { TouchableOpacity } from 'react-native';
//const logoIcon = { uri: 'https://res.cloudinary.com/dxfdmlk0f/image/upload/v1753805571/MeezaIcon_rt12hi.png', };
// const frontImage = { uri: 'https://res.cloudinary.com/dxfdmlk0f/image/upload/v1753806462/frontimage_zuzeje.jpg' }
import tablesR from '../../../assets/tablesR.jpg'
import homeR from '../../../assets/homeR.jpg'
import pullsR from '../../../assets/pullsR.jpg'
import doingsR from '../../../assets/d_oingsR.jpg'
import logoIcon from '../../../assets/meeza_icon.png'
import { Image } from 'expo-image';


const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const slides = [
    {
        key: 'one',
        title: 'The Doings app',
        text: `Celebrate differently with the world's first Celebratory Platform.`,
        image: homeR,
        // image: { uri: 'https://res.cloudinary.com/dxfdmlk0f/image/upload/v1753806462/frontimage_zuzeje.jpg' },
        backgroundColor: '#59b2ab',
    },
    {
        key: 'two',
        title: 'Tables',
        text: 'Share your celebrations, hangouts, parties and best moments of leisure on Meeza Tables.',
        image: tablesR,
        // image: { uri: 'https://res.cloudinary.com/dxfdmlk0f/image/upload/v1753807956/table_outdoor_jzhnml.jpg' },
        backgroundColor: '#febe29',
    },
    {
        key: 'three',
        title: 'Pulls',
        text: 'Celebrate the people who matter — your friends, your inspirations, your favorites — through Pulls. Let the world see how special they are.',
        image: pullsR,
        // image: { uri: 'https://res.cloudinary.com/dxfdmlk0f/image/upload/v1753808358/beautiful-afro-culture-women2_beu9wv.jpg' },
        backgroundColor: '#22bcb5',
    },
    {
        key: 'four',
        title: 'Doings Trend',
        text: 'Let people see your Doings. Discover higher tables and the most celebrated people in your city and around the world.',
        image: doingsR,
        // image: { uri: 'https://res.cloudinary.com/dxfdmlk0f/image/upload/v1753808358/beautiful-afro-culture-women2_beu9wv.jpg' },
        backgroundColor: '#22bc50ff',
    },
];

const OnboardingScreen = ({ onDone }) => {
    const handleDone = async () => {
        await AsyncStorage.setItem('hasSeenOnboarding', 'true');
        onDone();
    };

    const renderItem = ({ item }) => (
        // <View style={styles.slide}>
        //     <Image source={item.image} style={styles.fullscreenImage} resizeMode="cover" />
        //     <View style={styles.overlay}>
        //         {/* <Text style={styles.title}>{item.title}</Text> */}
        //         {/* <Text style={styles.text}>{item.text}</Text> */}
        //     </View>
        // </View>
        <View style={styles.slidee}>
            <Image
                // source={require('../../../assets/woman.jpg')}
                source={item.image}
                // style={[styles.image, { aspectRatio: imageAspectRatio }]}
                // resizeMode="cover"
                style={[styles.image, { backgroundColor: '#d6d4d4ff' }]}
                contentFit="cover"
                cachePolicy="disk"

            />
            <View style={styles.container}>
                <View style={styles.logoIconView}>
                    <Image
                        source={logoIcon}
                        style={[styles.logoIcon, { backgroundColor: '#d6d4d4ff' }]}
                        contentFit="cover"
                        cachePolicy="disk"
                    />

                </View>

                <Text style={styles.title}>{item.title}</Text>
                <Text style={styles.description}>
                    {item.text}
                </Text>
                {/* <TouchableOpacity
                    style={styles.getStartedBtn}
                    onPress={() => navigation.push('sign_in')}
                >
                    <Text style={styles.getStartedText}>Get Started</Text>
                </TouchableOpacity> */}
            </View>
        </View>
    );


    return (
        <SafeAreaView style={{ flex: 1 }}>
            <AppIntroSlider
                data={slides}
                renderItem={renderItem}
                // onDone={onDone}
                onDone={handleDone}
                showSkipButton={false}
                //  onSkip={onDone}
                onSkip={handleDone}
                activeDotStyle={{ backgroundColor: Colours.PRIMARY }}
                dotStyle={{ backgroundColor: Colours.PRIMARY_LIGHTER }}
                // renderSkipButton={() => (
                //     <Text style={styles.buttonText}>Skip</Text>
                // )}
                renderNextButton={() => (
                    <Text style={styles.buttonText}>Next</Text>
                )}
                renderDoneButton={() => (
                    <Text style={styles.buttonText}>Done</Text>
                )}
            />
        </SafeAreaView>
    );
};

const styles = StyleSheet.create({
    slidee: {
        display: 'flex',

        width: '100%',
        height: '100%',
    },
    imageContainer: {
        display: 'flex',
        height: '50%'

    },
    logoIconView: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor: 'green',
    },
    logoIcon: {
        height: dynamicSize(40),
        width: dynamicSize(40)
    },
    slide: {
        flex: 1,
        position: 'relative',
    },
    fullscreenImage: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    overlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: dynamicSpacing(20),
        // backgroundColor: 'rgba(0, 0, 0, 0.4)', // Optional dark overlay for readability
    },
    buttonText: {
        color: Colours.PRIMARY,
        fontSize: dynamicFontSize(16),
        fontFamily: 'Sen-Regular',
        paddingHorizontal: dynamicSpacing(20),
        paddingVertical: dynamicSpacing(10),
    },
    title: {
        fontSize: dynamicFontSize(28),
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: dynamicSpacing(10),
        textAlign: 'center',
    },
    text: {
        fontSize: dynamicFontSize(18),
        color: Colours.PRIMARY,
        textAlign: 'center',
    },


    screenContainer: {
        flex: 1, // Take up the entire screen
    },
    container: {
        backgroundColor: "white",
        marginTop: dynamicSpacing(-40),
        height: '50%',
        borderTopLeftRadius: dynamicSize(30),
        borderTopRightRadius: dynamicSize(30),
        padding: dynamicSpacing(25),
    },
    image: {
        width: '100%',
        // height: dynamicSize(550),
        height: '65%'
        // height: Math.min(dynamicSize(550), height * 0.72), // Limits height to 60% of screen height for tablets

    },
    getStartedBtn: {
        padding: dynamicSpacing(15),
        backgroundColor: Colours.PRIMARY,
        borderRadius: dynamicSize(99),
        marginTop: '5%',
    },
    title: {
        fontSize: dynamicFontSize(25),
        color: Colours.DARKGRAY,
        fontFamily: 'Sen-Bold',
        textAlign: 'center',
        marginTop: dynamicSpacing(10)
    },
    description: {
        fontSize: dynamicFontSize(17),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Regular',
        textAlign: 'center',
        marginTop: dynamicSpacing(20)
    },
    getStartedText: {
        fontSize: dynamicFontSize(17),
        color: "white",
        fontFamily: 'Sen-Regular',
        textAlign: 'center'
    }
});


export default OnboardingScreen;
